import React from 'react';
import './closeupoverlays.scss';

export const CloseUpOverlay = ({ 
    isOpen, 
    onClose, 
    title, 
    image, 
    commentary, 
    showCloseButton = true 
}) => {
    if (!isOpen) return null;

    return (
        <div className={`enlarged-overlay ${isOpen ? 'open' : ''}`}>
            <div className="enlarged-sticker">
                {showCloseButton && (
                    <div className="sticker-icon__shutdown" onClick={onClose}>
                        <p>X</p>
                    </div>
                )}
                <div className="sticker__title">
                    <p dangerouslySetInnerHTML={{ __html: title }} />
                </div>
                <div className="sticker__img">    
                    {image && (
                        <img 
                            src={require(`../../../components/images/${image}.png`)} 
                            alt="Illustrazione ingrandita" 
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    )} 
                </div>
                <div className="sticker__commentary">
                    <p dangerouslySetInnerHTML={{ __html: commentary }} />
                </div>
            </div>            
            {/* Backdrop click per chiudere */}
            <div className="overlay-backdrop" onClick={onClose} />
        </div>
    );
};
